import { SendRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useRef, useState } from "react";
import { Box, ListItem, ListItemButton, TextField } from "@mui/material";
import useAuth from "../../hooks/useAuth";
import useBotChat from "../../hooks/useBotChat";
import { ChatType } from "../../types/chatBot";

import { useParams } from "react-router-dom";

const ChatInputWidget: React.FC = () => {
  const { user } = useAuth();
  const { t } = useTranslation();

  const { contractId, vendorId } = useParams<string>();

  const {
    botName,
    setOpen: setShowBotChat,
    addedMessage,
    setAddedMessage,
  } = useBotChat();

  const inputRef = useRef(null);

  const [responding, setResponding] = useState(false);
  const [sentMessage, setSentMessage] = useState("");
  const [chatBoxType, setChatBoxType] = useState<ChatType>(ChatType.GENERAL);

  const handleEnterSentMessage = async (event: any) => {
    if (event.key === "Enter" && !!sentMessage && !responding) {
      setAddedMessage(sentMessage);
    }
  };

  const handleSendMessage = async () => {
    if (!!sentMessage && !responding) {
      setAddedMessage(sentMessage);
    }
  };

  return (
    <strong className="no-cursor">
      <Box display="flex" alignItems="center" pb={1}>
        <ListItem
          disablePadding
          secondaryAction={
            <SendRounded
              sx={{ cursor: "pointer" }}
              color="primary"
              onClick={handleSendMessage}
            />
          }
          sx={{ pb: 1 }}
        >
          <ListItemButton
            role={undefined}
            dense
            sx={{
              borderRadius: 2,
            }}
          >
            <TextField
              ref={inputRef}
              type="text"
              value={sentMessage}
              onInput={(e) =>
                setSentMessage((e.target as HTMLInputElement).value)
              }
              onKeyDown={handleEnterSentMessage}
              placeholder={t("Ask your question") + "..."}
              fullWidth
              size="small"
              variant="outlined"
              sx={{
                // no border
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "none",
                  },
                  "&:hover fieldset": {
                    border: "none",
                  },
                  "&.Mui-focused fieldset": {
                    border: "none",
                  },
                },
              }}
            />
          </ListItemButton>
        </ListItem>
      </Box>
    </strong>
  );
};

export default ChatInputWidget;
